<span
  class="watch-progress-chip"
  [ngClass]="['state-' + state, 'size-' + size, onVideo ? 'on-video' : '']"
  [attr.data-testid]="'watch-progress-chip'"
  [attr.data-state]="state"
  [attr.aria-label]="ariaLabel">
  <!-- The chip is its own gauge: a left-anchored fill behind the label, so the
       control bar gains no second bar that could read as a second scrubber. -->
  <span class="watch-progress-chip-fill" [style.width.%]="fillWidth" aria-hidden="true"></span>
  @if (state === 'watched') {
    <app-icon name="check" [size]="iconSize" class="watch-progress-chip-icon"></app-icon>
  }
  @if (state === 'watching') {
    <span class="watch-progress-chip-dot" [class.is-live]="live" aria-hidden="true"></span>
  }
  <span class="watch-progress-chip-label">
    {{ label }}@if (state !== 'not-started') {<span> · {{ percent | number:'1.0-0' }}%</span>}
  </span>
</span>
